/** Bordered card width on onboarding steps (Figma: 650px). */
export const ONBOARDING_CARD_WIDTH = 650

export const ONBOARDING_STEPPER_WIDTH = 174
export const ONBOARDING_STEPPER_GAP = 48

/** card + gap + stepper — hide stepper below this viewport width. */
export const ONBOARDING_STEPPER_BREAKPOINT = ONBOARDING_CARD_WIDTH + ONBOARDING_STEPPER_GAP + ONBOARDING_STEPPER_WIDTH + 48

export const onboardingPageWidth = (cardWidth = ONBOARDING_CARD_WIDTH) =>
    cardWidth + ONBOARDING_STEPPER_GAP + ONBOARDING_STEPPER_WIDTH
